var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.95153 1.83319C3.95153 2.84563 3.13078 3.66637 2.11834 3.66637C1.1059 3.66637 0.285156 2.84563 0.285156 1.83319C0.285156 0.820745 1.1059 0 2.11834 0C3.13078 0 3.95153 0.820745 3.95153 1.83319ZM0.285156 5.23767H4.03324V16.7606H0.285156V5.23767ZM14.2193 5.36531C14.2139 5.36355 14.2085 5.36177 14.2032 5.36C14.1771 5.35139 14.151 5.34278 14.1231 5.3351C14.0728 5.32357 14.0225 5.31414 13.9712 5.30576C13.7722 5.26596 13.5543 5.23767 13.2987 5.23767C11.1135 5.23767 9.72764 6.82679 9.27091 7.44064V5.23767H5.52283V16.7606H9.27091V10.4753C9.27091 10.4753 12.1034 6.53033 13.2987 9.42781V16.7606H17.0457V8.98471C17.0457 7.2437 15.8526 5.79287 14.2425 5.37281C14.2347 5.37034 14.227 5.36783 14.2193 5.36531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.af983e2456171ea766f716ee72e51cb1.svg";
export { ForwardRef as ReactComponent };